import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Col } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import { StyledCard, StatsGrid, StatCard, StyledStatistic } from './Styles';
import { addCommasInPrices } from './constants';
import { CustomerStatsSectionProps } from './types';

const CustomerStatsSection: React.FC<CustomerStatsSectionProps> = ({
  reportData,
}) => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };
  
  if (!reportData?.customerStats) {
    return null;
  }

  const customerStats = reportData.customerStats;

  return (
    <ThemeProvider theme={theme}>
      <StyledCard title="Customer Statistics">
        <StatsGrid gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={6} xl={6}>
            <StatCard>
              <StyledStatistic
                title="Total Customers"
                value={customerStats.totalCustomers || 0}
                suffix="customers"
              />
            </StatCard>
          </Col>
          <Col xs={24} sm={12} md={12} lg={6} xl={6}>
            <StatCard>
              <StyledStatistic
                title="New Customers"
                value={customerStats.newCustomers || 0}
                suffix="customers"
              />
            </StatCard>
          </Col>
          <Col xs={24} sm={12} md={12} lg={6} xl={6}>
            <StatCard>
              <StyledStatistic
                title="Repeat Customers"
                value={customerStats.repeatCustomers || 0}
                suffix="customers"
              />
            </StatCard>
          </Col>
          <Col xs={24} sm={12} md={12} lg={6} xl={6}>
            <StatCard>
              <StyledStatistic
                title="Average Spend"
                value={addCommasInPrices(customerStats.averageSpend || 0)}
                prefix="$"
              />
            </StatCard>
          </Col>
        </StatsGrid>
      </StyledCard>
    </ThemeProvider>
  );
};

export default CustomerStatsSection;
